import React from 'react'
import { useSelector, useDispatch } from 'react-redux';
import ModalActionButton from '../../elements/ModalActionButton';
import { updateStaff } from '../../../store/actions/staffActions';
import RadioGroup from '../../elements/form/RadioGroup';
const UpdateStaffType = ({ staff, currentStaffType, close }) => {
    const staffSelector = useSelector(state => state.staff);
    const dispatch = useDispatch();
    const [selectedStaffType, setSelectedStaffType] = React.useState(currentStaffType); 
    const updateStaffStaffType = () => {
        const payload = {
            staffType: selectedStaffType
        };
        dispatch(updateStaff(staff?._id, payload));
    };

    const staffTypeOptions = [
        {
            label: 'Academic Staff',
            value: 'ACADEMIC',
        },
        {
            label: 'Non-Academic Staff',
            value: 'NON_ACADEMIC',
        }
    ]
    return (
        <div className="w-full">
            <div className='mt-4'>
                <RadioGroup 
                    items={staffTypeOptions} 
                    inline={true}
                    preSelectedIndex={staffTypeOptions.findIndex(item => item.value === selectedStaffType.value)}
                    inputLabel={'Staff Type'}
                    requiredField={true}
                    returnSelected={(value) => {setSelectedStaffType(value.value)}} 
                    hasError={false}  
                    titleField='label'
                />
            </div>
            <div className="mt-8 flex flex-row-reverse gap-x-4">
                <ModalActionButton
                    buttonLabel={`Update Staff Type for ${staff?.name || 'Staff'}`}
                    buttonAction={updateStaffStaffType}
                    processing={staffSelector.updatingStaff}
                />

                <button
                    type="button"
                    className="inline-flex justify-center px-5 py-4 text-xs font-medium bg-transparent border border-transparent transition duration-200 hover:bg-opacity-5 rounded-xl hover:bg-secondary focus:outline-none"
                    onClick={close}
                >
                    Cancel
                </button>
            
            </div>
        </div>
    )
}

export default UpdateStaffType